import React from "react";
import { ReactComponent as DashboardIconlast1 } from "../../../../../../assets/svgs/dashboardlast11.svg";
import { ReactComponent as DashboardIconlast2 } from "../../../../../../assets/svgs/dashboardlast12.svg";
import { ReactComponent as DashboardIconlast3 } from "../../../../../../assets/svgs/dashboardlast13.svg";

import { THEME_COLORS } from "../../../../../../color";

const ReductionInFootpintEmission = ({ getComponent, activeDashboard }) => {
  const comp = getComponent ? getComponent("sc_footprint_reduction") : null;

  const footprintVal =
    activeDashboard === "live"
      ? comp?.data?.footprintReduction?.value !== undefined
        ? `${comp.data.footprintReduction.value}${comp.data.footprintReduction.unit || "%"}`
        : "0%"
      : "6%";

  const procurementVal =
    activeDashboard === "live"
      ? comp?.data?.totalProcurementValue?.value !== undefined
        ? `${(Number(comp.data.totalProcurementValue.value) / 10000000).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${comp.data.totalProcurementValue.unit || "Cr."}`
        : "0 Cr."
      : "3.5 Cr.";

  const footprintLabel =
    comp?.data?.footprintReduction?.label || "Footprint Emission of Suppliers";

  const procurementLabel =
    comp?.data?.totalProcurementValue?.label ||
    "Supplier emission per core of procurement";

  return (
    <div className="p-3 sm:p-5">
      {/* Header */}
      <div className="flex items-center mb-1">
        <div className="w-12 flex items-center justify-center">
          <DashboardIconlast1 className="w-12 h-12" />
        </div>
        <div className="px-5">
          <p
            className="font-[Calibri] font-bold text-base md:text-lg"
            style={{ color: THEME_COLORS.green }}
          >
            Percentage Of Reduction In Footprint Emission Of Suppliers
          </p>
        </div>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 xl:gap-4">
        {/* Card 1 */}
        <div className="p-3 xl:p-4 bg-[#E5F3F6] rounded-[10px] shadow-[0px_0px_16px_0px_#3BA2B91F] border border-[#D0ECF1] flex flex-col justify-between min-h-[120px]">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex-shrink-0 flex items-center justify-center">
              <DashboardIconlast2 className="w-10 h-10 xl:w-11 xl:h-11" />
            </div>
            <p
              className="text-[11px] xl:text-xs font-medium leading-tight"
              style={{ color: THEME_COLORS.green }}
            >
              {footprintLabel}
            </p>
          </div>
          <p
            className="text-2xl xl:text-3xl font-extrabold text-center mt-auto"
            style={{ color: THEME_COLORS.green }}
          >
            {footprintVal}
          </p>
        </div>

        {/* Card 2 */}
        <div className="p-3 xl:p-4 bg-white rounded-[10px] shadow-[0px_0px_16px_0px_#3BA2B91F] border border-[#3BA2B933] flex items-center justify-center min-h-[120px]">
          <p
            className="text-[11px] xl:text-xs font-normal text-center leading-normal"
            style={{ color: THEME_COLORS.green }}
          >
            Supplier emission per core of procurement
          </p>
        </div>

        {/* Card 3 */}
        <div className="p-3 xl:p-4 bg-[#E5F3F6] rounded-[10px] shadow-[0px_0px_16px_0px_#3BA2B91F] border border-[#D0ECF1] flex flex-col justify-between min-h-[120px]">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex-shrink-0 flex items-center justify-center">
              <DashboardIconlast3 className="w-10 h-9 xl:w-11 xl:h-10" />
            </div>
            <p
              className="text-[11px] xl:text-xs font-medium leading-tight ml-1"
              style={{ color: THEME_COLORS.green }}
            >
              {procurementLabel}
            </p>
          </div>
          <p
            className="text-2xl xl:text-3xl font-extrabold text-center mt-auto"
            style={{ color: THEME_COLORS.green }}
          >
            {procurementVal}
          </p>
        </div>

        {/* Card 4 */}
        <div className="p-3 xl:p-4 bg-white rounded-[10px] shadow-[0px_0px_16px_0px_#3BA2B91F] border border-[#3BA2B933] flex items-center justify-center min-h-[120px]">
          <p
            className="text-[11px] xl:text-xs font-normal text-center leading-normal"
            style={{ color: THEME_COLORS.green }}
          >
            Allocated towards enhancing supply chain sustainability and social
            impact initiatives
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReductionInFootpintEmission;
